<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Microscopy Data
      </h2>
      <p class="tw-italic tw-text-gray-700">
        View/Download microscopy data on core/buffer and new infections.
      </p>
    </b-container>

    <b-container fluid class="tw-mb-5">
      <b-row>
        <b-col cols="auto">
          <b-form-select size="lg" v-model="studyPhase" :options="studyPhaseOptions"></b-form-select>
        </b-col>
        <b-col>
          <b-form-select size="lg" v-model="coreOrBuffer" :options="coreOrBuffers">
            <template slot="first">
              <option value>-- Core And Buffer --</option>
            </template>
          </b-form-select>
        </b-col>
        <b-col>
          <b-form-select size="lg" v-model="newInfection" :options="newInfections">
            <template slot="first">
              <option value>-- ALL infections --</option>
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="auto">
          <b-button size="lg" variant="secondary" @click="downloadFile()" class="px-5">Download All</b-button>
        </b-col>
      </b-row>
    </b-container>

    <b-table
      ref="table"
      striped
      hover
      responsive
      :items="data"
      :fields="fields"
      :busy.sync="loading"
      :current-page="options.currentPage"
      :per-page="options.perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    ></b-table>

    <b-pagination
      v-model="options.currentPage"
      :total-rows="options.totalRows"
      :per-page="options.perPage"
      align="right"
      size="sm"
      class="my-0"
    ></b-pagination>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

export default {
  mixins: [DashboardBaseTemplate],
  data() {
    return {
      options: {
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
      },
      loading: false,
      search: "",
      fields: ["subject_id", "visit_code", "bloodslide_code", "bloodslide_taken_date", "bloodslide_obtained_from", "core_or_buffer", "finalmcrresult", "new_infection"],
      data: [],
      sortBy: "id",
      sortDesc: false,
      title: "",
      totalItems: 0,
      stacked: false,
      downloadUrl: '',
      newInfection: "",
      newInfections: [
        {value: 'yes', text: "New Infections Only"}
      ],
      coreOrBuffer: "",
      coreOrBuffers: [
        {value: 'core', text: "Core"},
        {value: 'buffer', text: "Buffer"}
      ],
      studyPhase: 'Cohort 2',
      studyPhaseOptions: ['Baseline', 'Cohort 1', 'Cohort 2']
    };
  },
  computed: {},
  watch: {
    coreOrBuffer: function() {
      this.find();
    },
    newInfection: function() {
      this.find();
    },
    studyPhase: function() {
      this.find();
    },
  },
  created() {
    this.find();
    this.downloadUrl = process.env.VUE_APP_AXIOS_BASE_URL + '/kenya/download/microscopy';
  },
  methods: {
    find() {
      const that = this;

      return HTTP.get("/kenya/table/microscopy", {
        params: {
            new_infection: that.newInfection,
            core_or_buffer: that.coreOrBuffer,
            study_phase: that.studyPhase
        },
      })
      .then((response) => {
        that.data = response.data;
        that.options.totalRows = that.data.length;
        that.totalItems = that.data.length;
      })
      .catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    },
    downloadFile: function() {
      const that = this;
      let downloadUrl = `${process.env.VUE_APP_AXIOS_BASE_URL}/kenya/download/microscopy?download=1`;
      HTTP.get(downloadUrl, {
        params: {
            new_infection: that.newInfection,
            core_or_buffer: that.coreOrBuffer,
            study_phase: that.studyPhase
        },
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `case-microscopy.csv`);
        document.body.appendChild(fileLink);
        fileLink.click();
      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    }
  },
};
</script>

<style></style>
